<template>
    <div>

        <c-panel title="Relatório de Notas" titleIcon="fa fa-file-pdf-o">

            <el-form label-position="top">

                <!-- NTI/SMED NÃO SÃO VINCULADOS A UMA INSTITUIÇÃO: PARA ELES A ESCOLHA É AQUI -->
                <el-row :gutter="10" v-if="precisaSelecionarInstituicao">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_id" filterable placeholder="Pesquisar instituição" @change="onChangeInstituicao" style="width: 100%;">
                                <el-option v-for="item in instituicoesOrdenadas" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-alert v-if="!instituicaoId && !precisaSelecionarInstituicao" type="info" show-icon :closable="false"
                          title="Nenhuma instituição selecionada"
                          description="Esta tela trabalha sobre a instituição ativa. Selecione uma instituição para gerar o relatório.">
                </el-alert>

                <el-row :gutter="10" v-else>

                    <el-col :xs="24" :sm="24" :md="6">
                        <el-form-item label="Consolidado por">
                            <el-select v-model="filtro.consolidado" @change="onChangeConsolidado" style="width: 100%;">
                                <el-option key="atividades" label="Atividade" value="atividades"></el-option>
                                <el-option key="periodo" label="Período" value="periodo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="porAtividade ? 8 : 10">
                        <el-form-item label="Turma">
                            <el-select v-model="filtro.turma_id" filterable placeholder="Selecione a turma" @change="onChangeTurma" style="width: 100%;">
                                <el-option-group v-for="grupo in turmasPorCurso" :key="grupo.curso" :label="grupo.curso">
                                    <el-option v-for="item in grupo.turmas" :key="item.id" :label="item.nome" :value="item.id">
                                        <span style="float: left;">{{ item.nome }}</span>
                                        <span style="float: right; color: #909399; font-size: 11px; margin-left: 20px;">{{ item.metodo_avaliacao == 'quantitativo' ? 'NOTA' : 'CONCEITO' }}</span>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="12" :md="porAtividade ? 6 : 8">
                        <el-form-item label="Disciplina">
                            <el-select v-model="filtro.disciplina" filterable placeholder="Selecione a disciplina" :disabled="!filtro.turma_id" style="width: 100%;">
                                <el-option v-for="item in disciplinasDaTurma" :key="item.id" :label="item.nome_area" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- O CONSOLIDADO POR PERÍODO JÁ TRAZ OS TRÊS PERÍODOS: O FILTRO NÃO FAZ SENTIDO -->
                    <el-col :xs="24" :sm="12" :md="4" v-if="porAtividade">
                        <el-form-item label="Período">
                            <el-select v-model="filtro.periodo_diario" placeholder="Selecione" :disabled="!filtro.turma_id" style="width: 100%;">
                                <el-option v-for="item in periodosDaTurma" :key="item.valor" :label="item.nome" :value="item.valor"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="10" v-if="instituicaoId">
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="limpar">Limpar</el-button>
                        <el-button type="primary" :loading="gerando" @click="gerar">GERAR RELATÓRIO</el-button>
                    </el-col>
                </el-row>

            </el-form>

            <el-alert v-if="turmaQualitativa" class="u-mt-10" type="info" show-icon :closable="false"
                      title="Turma qualitativa"
                      description="Esta turma não lança nota — a avaliação é por parecer. O relatório de notas não se aplica.">
            </el-alert>

        </c-panel>

    </div>
</template>

<script>
export default {
    name: 'RelatorioNotaDiario',

    data(){

        return {
            dados: { turmas: [], disciplinas: [], parametros_diario: [] },
            filtro: { instituicao_id: '', consolidado: 'atividades', turma_id: '', disciplina: '', periodo_diario: '' },
            gerando: false
        }
    },

    computed: {

        //MESMO CRITÉRIO USADO NA TELA DE DIÁRIO: ESSES TIPOS NÃO SÃO VINCULADOS A INSTITUIÇÃO
        precisaSelecionarInstituicao(){

            let tipo = Number(this.$store.state.user.tipo);

            return (tipo > 3 && tipo <= 8) || tipo == 10;
        },

        //A API DEVOLVE AS INSTITUIÇÕES COMO OBJETO INDEXADO PELO id, NÃO COMO ARRAY
        instituicoesOrdenadas(){

            return Object.values(this.$store.state.instituicoes || {})
                        .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        },

        instituicaoId(){

            if(this.precisaSelecionarInstituicao)
                return this.filtro.instituicao_id || null;

            return this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;
        },

        porAtividade(){

            return this.filtro.consolidado == 'atividades';
        },

        ehDocente(){

            return Number(this.$store.state.user.tipo) === 2;
        },

        //O DOCENTE SÓ ENXERGA AS TURMAS EM QUE ESTÁ ENTURMADO; OS DEMAIS VEEM TODAS
        turmasOrdenadas(){

            let lista = this.ehDocente
                            ? this.dados.turmas.filter(t => t.minha_turma)
                            : this.dados.turmas;

            return lista.slice().sort((a, b) => {

                let na = `${a.curso ? a.curso.nome : ''} ${a.nome}`;
                let nb = `${b.curso ? b.curso.nome : ''} ${b.nome}`;

                return na.localeCompare(nb, 'pt-BR');
            });
        },

        turmasPorCurso(){

            let grupos = [];
            let indice = {};

            for(let i in this.turmasOrdenadas){

                let turma = this.turmasOrdenadas[i];
                let curso = turma.curso && turma.curso.nome ? turma.curso.nome : 'SEM CURSO';

                if(typeof indice[curso] === 'undefined'){

                    indice[curso] = grupos.length;
                    grupos.push({ curso: curso, turmas: [] });
                }

                grupos[indice[curso]].turmas.push(turma);
            }

            return grupos;
        },

        turmaSelecionada(){

            return this.dados.turmas.find(t => t.id == this.filtro.turma_id);
        },

        turmaQualitativa(){

            return !!this.turmaSelecionada && this.turmaSelecionada.metodo_avaliacao != 'quantitativo';
        },

        //DOCENTE VÊ SÓ AS DISCIPLINAS EM QUE FOI ENTURMADO NAQUELA TURMA
        disciplinasDaTurma(){

            if(!this.turmaSelecionada)
                return [];

            let ids = this.ehDocente
                        ? (this.turmaSelecionada.disciplinas || []).map(d => Number(d.id ? d.id : d))
                        : []
                            .concat(this.turmaSelecionada.areas_cobhecimento_principais || [])
                            .concat(this.turmaSelecionada.areas_cobhecimento_diversificadas || [])
                            .map(Number);

            return this.dados.disciplinas
                        .filter(d => ids.includes(Number(d.id)))
                        .sort((a, b) => a.nome_area.localeCompare(b.nome_area, 'pt-BR'));
        },

        periodosDaTurma(){

            if(!this.turmaSelecionada || !this.turmaSelecionada.periodos_diario)
                return [];

            return this.turmaSelecionada.periodos_diario.map((nome, i) => {

                return { nome: nome, valor: i + 1 };
            });
        }
    },

    mounted(){

        this.init();
    },

    methods: {

        init(){

            if(!this.instituicaoId)
                return;

            window.eventBus.$emit('loading', true);

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/nota/initFormNotas/${this.instituicaoId}`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },

        onChangeInstituicao(){

            this.dados = { turmas: [], disciplinas: [], parametros_diario: [] };
            this.limpar();
            this.init();
        },

        onChangeTurma(){

            this.filtro.disciplina = '';
            this.filtro.periodo_diario = '';
        },

        onChangeConsolidado(){

            this.filtro.periodo_diario = '';
        },

        limpar(){

            this.filtro.turma_id = '';
            this.filtro.disciplina = '';
            this.filtro.periodo_diario = '';
        },

        validar(){

            if(!this.filtro.turma_id || !this.filtro.disciplina){

                window.eventBus.$emit('alert', {msg: 'Selecione a turma e a disciplina.', type: 'warning'});
                return false;
            }

            if(this.porAtividade && !this.filtro.periodo_diario){

                window.eventBus.$emit('alert', {msg: 'Selecione o período.', type: 'warning'});
                return false;
            }

            if(this.turmaQualitativa){

                window.eventBus.$emit('alert', {msg: 'Esta turma é qualitativa: a avaliação é por parecer, não por nota.', type: 'warning'});
                return false;
            }

            return true;
        },

        gerar(){

            if(!this.validar())
                return;

            this.gerando = true;

            let payload = {
                turma_id: this.filtro.turma_id,
                disciplina: this.filtro.disciplina,
                consolidado: this.filtro.consolidado,
                //NO CONSOLIDADO POR PERÍODO O BACKEND PERCORRE TODOS OS PERÍODOS
                periodo_diario: this.porAtividade ? this.filtro.periodo_diario : ''
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioDiarioNota`, payload, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.gerando = false;

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                //ABRE EM OUTRA ABA; SE O NAVEGADOR BLOQUEAR, NAVEGA NA MESMA
                const aba = window.open(url, '_blank');

                if(!aba)
                    window.location.href = url;

            }).catch((error) => { this.gerando = false; this.$store.commit('throwException', error); });
        }
    }
}
</script>
